// ============================================================
// main.tsx — React-Einstiegspunkt
// ============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { AppProvider } from './store';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root fehlt im DOM');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
);
